import React, { useState } from 'react';

const UfwCommandGenerator = () => {
  const [inputIp, setInputIp] = useState('');
  const [inputPort, setInputPort] = useState('');
  const [knownPort, setKnownPort] = useState('');
  const [operation, setOperation] = useState('allow-port');
  const [useSudo, setUseSudo] = useState(true);
  const [applyNow, setApplyNow] = useState(true);
  const [command, setCommand] = useState('');
  const [history, setHistory] = useState([]);
  const [sequence, setSequence] = useState([]);

  const handleInputPortChange = (event) => {
    setInputPort(event.target.value);
  };

  const handleInputIpChange = (event) => {
    setInputIp(event.target.value);
  };

  const handleOperationChange = (event) => {
    setOperation(event.target.value);
  };

  const handleSudoChange = () => {
    setUseSudo(!useSudo);
  };

  const handleApplyNow = () => {
    setApplyNow(!applyNow);
  };

  const handleKnownPortChange = (event) => {
    const selectedPort = event.target.value;
    setKnownPort(selectedPort);
    setInputPort(selectedPort);
  };

  const copyToClipboard = () => {
    if (command) {
      navigator.clipboard.writeText(command).then(() => {
        // alert('Command copied to clipboard!');
      }).catch(err => {
        console.error('Error copying text: ', err);
      });
    }
  };

  const copyHistoryToClipboard = () => {
    if (history) {
      const historyStr = history.join("\n");
      navigator.clipboard.writeText(historyStr).then(() => {
        // alert('Command copied to clipboard!');
      }).catch(err => {
        console.error('Error copying text: ', err);
      });
    }
  };

  const copySequenceToClipboard = () => {
    if (sequence) {
      const sequenceStr = sequence.join("\n");
      navigator.clipboard.writeText(sequenceStr).then(() => {
        // alert('Command copied to clipboard!');
      }).catch(err => {
        console.error('Error copying text: ', err);
      });
    }
  };


  const clearHistory = () => {
    setHistory([]);
  }

  const clearSequence = () => {
    setSequence([]);
  }
  

  const generateCommand = () => {
    let baseCommand = (useSudo ? 'sudo ' : '') + 'ufw ';
    switch(operation) {
      case 'allow-port':
        baseCommand += `allow ${inputPort}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
        break;
      case 'deny-port':
        baseCommand += `deny ${inputPort}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
        break;
      case 'allow-ip':
        baseCommand += `allow from ${inputIp}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
        break;
      case 'deny-ip':
        baseCommand += `deny from ${inputIp}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
      break;
      case 'allow-ip-port':
        baseCommand += `allow from ${inputIp} to any port ${inputPort}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
        break;
      case 'deny-ip-port':
        baseCommand += `deny from ${inputIp} to any port ${inputPort}`;
        if (applyNow) {
          baseCommand += "&& ufw reload";
        }
        break;
      case 'status':
        baseCommand = (useSudo ? 'sudo ' : '') + 'ufw status verbose';
        break;
      case 'reset':
        baseCommand = (useSudo ? 'sudo ' : '') + 'ufw reset';
        break;
      case 'enable': 
        baseCommand = (useSudo ? 'sudo ' : '') + 'ufw enable';
        break;
      case 'disable':
        baseCommand = (useSudo ? 'sudo ' : '') + 'ufw disable';
        break;
      case 'reload':
        baseCommand = (useSudo ? 'sudo ' : '') + 'ufw reload';
        break;
      default:
        baseCommand = 'Invalid operation';
    }
    setCommand(baseCommand);
    setHistory(prevHistory => [baseCommand + ";", ...prevHistory]);
    setSequence(prevSequence => [...prevSequence, baseCommand + ";"]);
  };

  return (
  <div className={"row my-5 rounded shadow p-3"}>
    <div className={"col-lg-6 border border-5 border-warning rounded p-4 shadow"}>
        <h3 className={"mb-3"}>UFW Command Parameters</h3>
          <div className={"d-flex flex-row"}>
            <input type="text" value={inputIp} onChange={handleInputIpChange} placeholder="ip" className={"form-control mx-2"} />:
            <input type="text" value={inputPort} onChange={handleInputPortChange} placeholder="port" className={"form-control mx-2"} />or
                <select value={knownPort} onChange={handleKnownPortChange} className={"form-select mx-2"}>
                    <option value="">Select a Known Port</option>
                    <option value="20">FTP Data (20)</option>
                    <option value="21">FTP Control (21)</option>
                    <option value="22">SSH (22)</option>
                    <option value="23">Telnet (23)</option>
                    <option value="25">SMTP (25)</option>
                    <option value="53">DNS (53)</option>
                    <option value="67">DHCP (67)</option>
                    <option value="68">DHCP (68)</option>
                    <option value="80">HTTP (80)</option>
                    <option value="110">POP3 (110)</option>
                    <option value="119">NNTP (119)</option>
                    <option value="123">NTP (123)</option>
                    <option value="137">NetBIOS Name Service (137)</option>
                    <option value="138">NetBIOS Datagram Service (138)</option>
                    <option value="139">NetBIOS Session Service (139)</option>
                    <option value="143">IMAP (143)</option>
                    <option value="161">SNMP (161)</option>
                    <option value="162">SNMP Trap (162)</option>
                    <option value="179">BGP (179)</option>
                    <option value="443">HTTPS (443)</option>
                    <option value="993">IMAPS (993)</option>
                    <option value="995">POP3S (995)</option>
                    <option value="1433">MSSQL (1433)</option>
                    <option value="1521">Oracle Database (1521)</option>
                    <option value="3306">MySQL (3306)</option>
                    <option value="3389">RDP (3389)</option>
                    <option value="5432">PostgreSQL (5432)</option>
                    <option value="5900">VNC (5900)</option>
                </select>
          </div>
          <div className={"row text-start form-check form-switch mx-1 my-3"}>
              <label className={"form-check-label"}>
                  <input type="checkbox" checked={applyNow} onChange={handleApplyNow} className={"form-check-input"} /> Apply immediately after generated command
              </label>
              <label className={"form-check-label"}>
                <input type="checkbox" checked={useSudo} onChange={handleSudoChange} className={"form-check-input"}/> Use 'sudo' with commands
              </label>
        </div>
          <div className={"row"}>
                <div className={"col-lg-2"}><p className={"fs-5"}>Action</p></div>
              <div className={"col-lg-5"}>
                <select value={operation} onChange={handleOperationChange} className={"form-select text-center"}>
                  <option value="reload">[Apply Rules]</option>
                  <option value="allow-port">Allow Port</option>
                  <option value="allow-ip">Allow IP</option>
                  <option value="allow-ip-port">Allow IP & Port</option>
                  <option value="deny-port">Deny Port</option>
                  <option value="deny-ip">Deny IP</option>
                  <option value="deny-ip-port">Deny IP & Port</option>
                  <option value="status">Status</option>
                  <option value="reset">Reset</option>
                  <option value="enable">Enable</option>
                  <option value="disable">Disable</option>
                </select>
              </div>
          </div>
          <div>
            <button onClick={generateCommand} className={"btn btn-warning m-3"}>Generate Command</button>
          </div>
          <div className={"row"}>
              <div className={"col-lg-10 col-md-10 d-flex justify-content-end"}>
                  <div className={"badge bg-dark text-white rounded text-wrap"}>
                    {command && <p className={"my-3 fs-6"}>[root@MasteringUnixShell ~]# <strong className={"text-warning"}>{command}</strong></p>}
                  </div>
              </div>
              <div className={"col-lg-2 col-md-2 d-flex justify-content-start"}>
                  {command && <button onClick={copyToClipboard} className={"btn btn-warning my-3 my-md-0 my-lg-0"}>Copy</button>}
              </div>
          </div>
    </div>



      <div className={"col-lg-6 row"}>
          <div className={"col-lg-6"}>
              <h3>Sequence of UFW Commands for Unix Command Line:</h3>
                <button onClick={clearSequence} className={"btn btn-warning me-2 mt-lg-3"}>Clear Sequence</button>
                <button onClick={copySequenceToClipboard} className={"btn btn-warning mt-lg-3"}>Copy Sequence</button>
                <p>
                {sequence.map((cmd, index) => (
                <div key={index}>{cmd}</div>
                ))}
                </p>
          </div>

          <div className={"col-lg-6"}>
              <h3>History of UFW Commands</h3>
                <button onClick={clearHistory} className={"btn btn-warning me-2 mt-lg-5"}>Clear History</button>
                <button onClick={copyHistoryToClipboard} className={"btn btn-warning mt-lg-5"}>Copy History</button>
                <p>
                {history.map((cmd, index) => (
                <div key={index}>{cmd}</div>
                ))}
                </p>
          </div>
      </div>
  </div>
  );
};

export default UfwCommandGenerator;
